import { IVideoTrack } from 'features/video-conference/utils';

const videoRegistry = new WeakMap<HTMLVideoElement, () => void>();

export function cleanupVideoWorkaround(el: HTMLVideoElement): void {
  const cleanup = videoRegistry.get(el);
  if (cleanup) {
    cleanup();
    videoRegistry.delete(el);
  }
}

export function applyVideoLogic(
  track: IVideoTrack,
  el: HTMLVideoElement,
): void {
  cleanupVideoWorkaround(el);

  let wasInterrupted = false;

  const reattach = () => {
    if (wasInterrupted) {
      track.detach(el);
      track.attach(el);
      wasInterrupted = false;
    }
  };

  const onPause = () => {
    wasInterrupted = true;
  };
  const onPlay = () => {
    reattach();
  };
  const onVisibilityChange = () => {
    if (document.visibilityState === 'visible') reattach();
  };

  el.addEventListener('pause', onPause);
  el.addEventListener('play', onPlay);
  document.addEventListener('visibilitychange', onVisibilityChange);

  videoRegistry.set(el, () => {
    el.removeEventListener('pause', onPause);
    el.removeEventListener('play', onPlay);
    document.removeEventListener('visibilitychange', onVisibilityChange);
  });
}

export const isIOS15 = (): boolean => {
  if (typeof navigator === 'undefined') return false;

  return /iP(ad|hone|od).+Version\/15/.test(navigator.userAgent);
};

export const isSafari = (): boolean => {
  if (typeof navigator === 'undefined') return false;

  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
};

export const isIOS15Safari = (): boolean => isIOS15() && isSafari();

export const isIOS16 = (): boolean => {
  if (typeof navigator === 'undefined') return false;

  return /iP(ad|hone|od).+Version\/16/.test(navigator.userAgent);
};
